import './tailwind.css';
import 'react-toastify/dist/ReactToastify.css';
import { FunctionComponent } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter} from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import store from '~/store';
import { AuthRoutes } from './resources/routes/AuthRoutes';


const App: FunctionComponent = () => {
  return (
    <div className="text-theme-gray">
      <Provider store={store}>
        <ToastContainer />
        <BrowserRouter>
          <AuthRoutes />
        </BrowserRouter>
      </Provider>
    </div>
  );
};
export default App;